export const SIGN_IN = "SIGN_IN";
export const PROFILE_INFO = "PROFILE_INFO";
export const UPDATE_OUTOFOFFICE = "UPDATE_OUTOFOFFICE";